import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";

import {
  IAPI_FAC001_Request,
  IAPI_FAC001_Response,
} from "../../../type/apiType";

import {
  IAPI_APP016_Request,
  IAPI_APP016_Response,
} from "../../../type/apiType";

// 「施設を転換後加入させない旨の届」の取り下げ一覧参照
// API仕様書_施設
const httpIAPI_FAC001 = async (
  param: IAPI_FAC001_Request
): Promise<IAPI_FAC001_Response> => {
  let res = await http.post(ApiUrl.API_FAC001, {
    ...param,
  });
  return res.data;
};

//申請状況更新
//API仕様書_申請情報
const httpIAPI_APP016 = async (
  param: IAPI_APP016_Request
): Promise<IAPI_APP016_Response> => {
  let res = await http.post(ApiUrl.API_APP016, {
    ...param,
  });
  return res.data;
};

export { httpIAPI_FAC001, httpIAPI_APP016 };
